"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["data-test"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["value"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: "payments_type input-group",
        "data-test": _ctx.unit
    }, [
        (0, vue_1.createElementVNode)("i", {
            class: (0, vue_1.normalizeClass)(["resource_icon payments_type_icon", _ctx.iconClass]),
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('plus'))),
            title: _ctx.$t('Pay with ' + _ctx.description)
        }, null, 10, _hoisted_2),
        (0, vue_1.createVNode)(_component_AppButton, {
            type: "minus",
            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('minus')))
        }),
        (0, vue_1.createElementVNode)("input", {
            class: "form-input form-inline payments_input",
            value: _ctx.modelValue,
            onInput: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, null, 40, _hoisted_3),
        (0, vue_1.createVNode)(_component_AppButton, {
            type: "plus",
            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('plus')))
        }),
        (_ctx.showMax)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_AppButton, {
                key: 0,
                type: "max",
                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('max'))),
                title: "MAX"
            }))
            : (0, vue_1.createCommentVNode)("", true)
    ], 8, _hoisted_1));
}
